<!-- eslint-disable no-trailing-spaces -->
<template>
  <div>
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1>{{ $tc('request_stars.request_a_star', 1) }}</h1>
      </div>
    </div>

    <form @submit.prevent>
      <div class="container-fluid" v-if="!$userIsClient">
        <div class="panel panel-send-request">
          <div class="panel-body">

            <div v-if="$requestFormConfig.show_requester_heading" >
              <h3>Requested By</h3>

              <hr />
            </div>

            <div class="row">
              <div class="col-xs-12">
                <div class="radio radio-primary col-xs-4">
                  <input
                    type="radio"
                    name="existing_client"
                    id="existing_client_id"
                    :value="true"
                    v-model="existingClient"
                  >
                  <label for="existing_client_id">
                    {{ $tc('request_stars.existing_client', 1) }}
                  </label>
                </div>
                <div :class="['form-group col-xs-8', hasErrorClass($v.selectedClient)]" v-show="existingClient" v-if="!booking.is_offer">
                  <selectize
                    ref="clients"
                    name="clients"
                    class="selectize selectize-single"
                    key-context="clients"
                    :placeholder="$tc('request_stars.existing_client', 2)"
                    autocomplete="off"
                    v-model="$v.selectedClient.$model"
                    :fetch-results="handleGetClientsCallback"
                    :fetch-more-results="handleGetNextClientsCallback"
                    :options="clientOptions"/>
                  <vuelidate-help :field="$v.selectedClient" :label="$tc('request_stars.existing_client', 1)" />
                </div>
                <div :class="['form-group col-xs-8', hasErrorClass($v.selectedClient)]" v-show="existingClient" v-else>
                  <selectize
                    ref="clients"
                    name="clients"
                    class="selectize selectize-single"
                    key-context="clients"
                    :placeholder="Admins"
                    autocomplete="off"
                    v-model="$v.selectedClient.$model"
                    :fetch-results="handleGetAdminsCallback"
                    :fetch-more-results="handleGetNextAdminsCallback"
                    :options="clientOptions"/>
                  <vuelidate-help :field="$v.selectedClient" label="Existing Admins" />
                </div>
              </div>

              <div v-if="$requestFormConfig.allow_create_client && !booking.is_offer" class="col-xs-12">
                <div class="radio radio-primary">
                  <input
                    type="radio"
                    name="profile_visibility"
                    id="profile_visibility_hidden"
                    :value="false"
                    v-model="existingClient">
                  <label for="profile_visibility_hidden">
                    {{ $tc('request_stars.new_client', 1) }}
                  </label>
                </div>
                <div class="form-horizontal panel-body panel panel-grey" v-show="!existingClient">
                  <create-user ref="createUser" />
                  <div class="row">
                    <div class="col-md-12 col-lg-6">
                      <field-input :model="$v.newClient.company" v-bind:field-name="$t('organisation') | sentenceCase" :show-required="showClientDepartmentFields"/>
                    </div>
                    <div class="col-md-12 col-lg-6">
                      <field-input :model="$v.newClient.position" field-name="Job Title" :show-required="showClientDepartmentFields"/>
                    </div>
                  </div>
                  <div class="row" v-if="$showDepartmentField">
                    <div class="col-md-12 col-lg-6">
                      <department-selection :model="$v.newClient.department_id" @input="handleDepartmentSelected" @added="handleDepartmentAdded"/>
                    </div>
                  </div>
                  <div class="row spacer-t-3" v-if="$activeClientModuleEnabled">
                    <div class="col-md-12 col-lg-6">
                      <field-input :model="$v.newClient.password" field-name="Password"
                                   type="password"/>
                    </div>
                    <div class="col-md-12 col-lg-6">
                      <field-input :model="$v.newClient.password_confirmation"
                                   field-name="Password Confirmation" type="password"/>
                    </div>
                  </div>
                </div>
              </div>
          </div>
          </div>
        </div>
      </div>

      <div class="container-fluid">
        <booking-form
          ref="form"
          :property-mutator="setRequestProperty"
          :booking="booking"
          :validationTriggered="validationTriggered"
          :additional-departments="additionalDepartments"
        >
        </booking-form>

        <div class="dashboard-block">
          <ladda-button
            v-if="$userIsAdmin"
            ref="publishbtn"
            :click="() => { return handleSubmitRequestCallback('request') }"
            class="btn btn-primary">
            {{ !$vlastMode ? 'Save' : 'Publish' }} {{ $t('Request') }}
          </ladda-button>
          <ladda-button
            ref="addanotherbtn"
            :click="() => { return handleSubmitRequestCallback($userIsAdmin ? 'request' : 'vetting', true) }"
            class="btn btn-outline">
            {{ $vlastMode && $userIsAdmin ? 'Publish' : $vlastMode && $userIsClient ? 'Submit' : 'Save' }} and add another
          </ladda-button>
          <ladda-button
            ref="draftbtn"
            :click="() => { return handleSubmitRequestCallback('vetting') }"
            class="btn btn-outline">
            {{ $userIsAdmin ? 'Save As Pending' : 'Submit For Approval' }}
          </ladda-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import {cloneDeep, each} from 'lodash'
import {notify} from 'utils'
import BookingForm from 'components/booking/BookingForm'
import ClientSelectize from './ClientSelectize'
import Selectize from '../../ext/codium/CodiumSelectize'
import { requiredIf } from 'vuelidate/lib/validators'
import VuelidateHelp from '../../misc/VuelidateHelp'
import FieldInput from '../../misc/FieldInput'
import DepartmentSelection from '../../misc/DepartmentSelection'
import CreateUser from '../../CreateUser'
import * as Sentry from '@sentry/browser'

export default {
  props: ['id'],

  data () {
    return {
      validationTriggered: false,
      existingClient: true,
      selectedClient: null,
      clientOptions: [],
      newClient: {
        department_id: null,
        password: null,
        password_confirmation: null,
        company: null,
        position: null
      },
      additionalDepartments: []
    }
  },

  components: {
    CreateUser,
    FieldInput,
    DepartmentSelection,
    ClientSelectize,
    BookingForm,
    Selectize,
    VuelidateHelp
  },

  computed: {
    ...mapState('booking/request', {booking: 'request'}),
    ...mapState('booking/request', ['formStatus']),
    ...mapState('client', ['clients']),
    ...mapState('user', ['user']),
    ...mapState('shortlist', ['shortlist']),

    isExistingClient () {
      return this.existingClient
    },

    showClientDepartmentFields () {
      return this.$showDepartmentField && !this.isExistingClient && !this.$userIsClient
    }
  },

  validations () {
    return {
      selectedClient: {
        required: requiredIf(function (model) {
          return this.isExistingClient && !this.$userIsClient
        })
      },
      newClient: {
        password: {
          required: requiredIf(function (model) {
            return !this.isExistingClient && !this.$userIsClient && this.$activeClientModuleEnabled
          })
        },
        password_confirmation: {
          required: requiredIf(function (model) {
            return !this.isExistingClient && !this.$userIsClient && this.$activeClientModuleEnabled
          }),
          sameAsPassword (value) {
            if (this.isExistingClient || this.$userIsClient || !this.$activeClientModuleEnabled) {
              return true
            }
            return value === this.newClient.password
          }
        },
        department_id: {
          required: requiredIf(function (model) {
            return this.showClientDepartmentFields
          })
        },
        company: {
          required: requiredIf(function (model) {
            return this.showClientDepartmentFields
          })
        },
        position: {
          required: requiredIf(function (model) {
            return this.showClientDepartmentFields
          })
        }
      }
    }
  },

  created () {
    this.resetBookingRequest()
    if (this.$userIsAdmin) {
      this.handleGetClientsCallback('', false)
    }
    this.resetUser()
  },

  methods: {
    ...mapActions('booking/request', ['getBookingRequest', 'updateBookingRequest', 'setRequestProperty',
      'submitBookingRequest', 'resetBookingRequest', 'resetBookingRequest', 'setFormStatus']),
    ...mapActions('client', ['getClients', 'getNextClients']),
    ...mapActions('user', ['resetUser']),
    ...mapActions('shortlist', ['clearShortlist']),
    ...mapActions('booking/file', ['storeBookingFile']),

    handleDepartmentSelected (department) {
      this.booking.department_id = department
    },

    handleDepartmentAdded (department) {
      this.additionalDepartments.push(department)
    },

    hasErrorClass (field) {
      return { 'has-error': field.$error }
    },

    handleGetClientsCallback (term, focus = true) {
      return this.getClients({ keywords: term, active: 1 }).then((response) => {
        this.pushClientOptions(response, [])
      }).catch(() => {
      })
    },

    handleGetNextClientsCallback (term) {
      return this.getNextClients({ keywords: term, active: 1 }).then((response) => {
        this.pushClientOptions(response, cloneDeep(this.clientOptions))
      }).catch(() => {
      })
    },

    pushClientOptions (response, initialOptions) {
      let newClientOptions = initialOptions
      response.data.data.forEach(client => newClientOptions.push({
        id: client.id,
        text: this.$showDepartmentField && client.department ? `${client.name} - ${client.department.name}` : client.name
      }))
      this.clientOptions = newClientOptions
      if (focus) {
        this.$refs.clients.selectize.focus()
      }
    },

    validateAll () {
      this.$v.$touch()
      if (this.$refs && this.$refs.createUser) {
        this.$refs.createUser.validate()
      }
      this.validationTriggered = true
      if (!this.formStatus) {
        return false
      }
      if (this.$userIsClient) {
        return true
      }
      if (this.existingClient) {
        return !this.$v.$invalid && !this.$v.selectedClient.$invalid
      } else {
        return !this.$v.$invalid && !this.$refs.createUser.invalid
      }
    },

    fileUpload (id, files) {
      if (!files.length) {
        return Promise.resolve()
      } else {
        return Promise.all(files.map(file => {
          this.storeBookingFile({ id: id, file: file })
            .catch(() => {
              notify.error('Something went wrong uploading your file. Please try again.')
            })
        }))
          .then(Promise.resolve())
          .catch(Promise.reject(new Error('Something went wrong when uploading the file')))
      }
    },

    async handleSubmitRequestCallback (type, addAnother = false) {
      const validationResult = this.validateAll()
      if (!validationResult) {
        notify.error('There were form validation issues, please fix them and try again.')
        return Promise.resolve()
      }

      let payload = this.booking
      if (this.$userIsClient || (this.booking.is_offer && this.$userIsAdmin)) {
        payload.client = this.$user.id
      } else if (this.existingClient) {
        payload.client = this.selectedClient
      } else {
        payload.first_name = this.$refs.createUser.payload.first_name
        payload.last_name = this.$refs.createUser.payload.last_name
        payload.email = this.$refs.createUser.payload.email
        payload.phone = this.$refs.createUser.payload.phone
        payload.password = this.newClient.password
        payload.password_confirmation = this.newClient.password_confirmation
        payload.client_department_id = this.newClient.department_id
        payload.company = this.newClient.company
        payload.position = this.newClient.position
      }
      payload.shortlist = []
      each(this.shortlist, (star) => {
        payload.shortlist.push(star)
      })

      payload.custom_type = type
      payload.client_agreed_terms_on_request_creation = true

      return this.submitBookingRequest(payload)
        .then((response) => {
          this.fileUpload(response.data.id, payload.files)
            .then(() => {
              this.resetBookingRequest()
              this.clearShortlist()
              this.setFormStatus(false)

              if (addAnother) {
                this.$router.go()
              } else if (type === 'vetting' && this.$userIsAdmin) {
                this.$router.push({ name: 'vetting.show', params: { id: response.data.id } })
              } else if (response.data.is_offer && (this.$userIsAdmin || this.$userIsClient)) {
                this.$router.push({ name: 'bookings.show', params: { id: response.data.id } })
              } else {
                this.$router.push({ name: 'requests.show', params: { id: response.data.id } })
              }
            })
        })
        .catch((error) => {
          notify.error('Something went wrong creating the ' + this.$t('request'))
          Sentry.captureException(error)
          return Promise.resolve()
        })
    },

    handleIsOfferTriggered (isOffer) {
      return this.getClients({ offer: 1, active: 1 }).then((response) => {
        this.pushClientOptions(response, [])
      }).catch(() => {
      })
    }
  }
}
</script>
